import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import portal from './modules/portal'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    global,
    portal
  }
})
export default store
